module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b85e066f510dd21ad5c57c66944a5fcf.png";